import { Modal, Title } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { useRootStore } from 'stores/global/RootStore/context';

import ContactsModal from './ContactsModal';

const TeamResponsibleDrawer: React.FC = () => {
  const { teamResponsibleStore } = useRootStore();
  const { openDrawer } = teamResponsibleStore;
  const model = teamResponsibleStore.teamResponsible.value;

  if (!model?.contacts?.length) {
    return null;
  }

  return (
    <Modal
      opened={openDrawer.isOpen}
      onClose={openDrawer.close}
      centered
      size="xs"
      title={
        <Title fw={600} size="h5">
          Способы связи
        </Title>
      }
      overlayProps={{
        backgroundOpacity: 0.32,
        blur: 8,
      }}
    >
      <ContactsModal contacts={model.contacts} />
    </Modal>
  );
};

export default observer(TeamResponsibleDrawer);
